"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleData = exports.COUNTRIES_CODES = exports.getCountryCodeByGEO = void 0;
var tslib_1 = require("tslib");
var resources_1 = require("./resources");
var constants_1 = require("./country-codes/constants");
var country_codes_1 = require("./country-codes");
Object.defineProperty(exports, "getCountryCodeByGEO", { enumerable: true, get: function () { return country_codes_1.getCountryCodeByGEO; } });
Object.defineProperty(exports, "COUNTRIES_CODES", { enumerable: true, get: function () { return country_codes_1.COUNTRIES_CODES; } });
var COUNTRY_TRANSLATION_PREFIX = 'locale-dataset.countries.';
var LocaleData = /** @class */ (function () {
    function LocaleData() {
    }
    LocaleData.prototype.setTranslations = function (_i18n) {
        this.translations = _i18n;
    };
    LocaleData.prototype.loadTranslations = function (createI18Next, loadTranslations) {
        var _this = this;
        this.translations = createI18Next({
            asyncMessagesLoader: function (locale) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var translations;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, loadTranslations(locale)];
                        case 1:
                            translations = _a.sent();
                            return [2 /*return*/, translations];
                    }
                });
            }); },
        });
    };
    LocaleData.prototype.getAllCountries = function (existingCountries) {
        var _this = this;
        return (existingCountries || resources_1.countries)
            .reduce(function (acc, value) {
            var label = _this.getCountryByKey(value);
            if (label) {
                acc.push({ value: value, label: label });
            }
            return acc;
        }, [])
            .sort(function (_a, _b) {
            var firstName = _a.label;
            var secondName = _b.label;
            return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
        });
    };
    LocaleData.prototype.getCountryByKey = function (key) {
        if (constants_1.GEO_CODE_MAP[key]) {
            return this.translations.t("".concat(COUNTRY_TRANSLATION_PREFIX).concat(key));
        }
    };
    return LocaleData;
}());
exports.LocaleData = LocaleData;
//# sourceMappingURL=index.js.map